export const TITLE = "title";
export const DATE = "date";
export const TIME = "time";
export const SCHEDULED_AT = "scheduledAt";
export const LANGUAGE = "language";
export const DESCRIPTION = "description";
